import React from 'react';
import useScreenSize from '../Hooks/useScreenSize';

/**
 * VaultDome - Responsive Engineering Wrapper
 * Uses the custom useScreenSize hook to shrink the arc for mobile.
 */
const VaultDome = ({
    children,
    color = "#0772BF", 
    height = 120,      // Desktop Arc Height
    offset = 40,       // Desktop Content Offset
    className = ""
}) => {
    const { isSmallScreen } = useScreenSize();

    // Logic: If on a small screen, shrink height by 50% and offset by 50%
    const currentHeight = isSmallScreen ? height * 0.5 : height;
    const currentOffset = isSmallScreen ? offset * 0.5 : offset;

    return (
        <section className={`relative w-full overflow-visible ${className}`}>
            {/* 1. The Dynamic SVG Arc */}
            <div
                className="absolute left-0 w-full pointer-events-none z-0 transition-all duration-500 ease-in-out"
                style={{
                    top: `-${currentHeight - 1}px`,
                    height: `${currentHeight}px`
                }}
            >
                <svg
                    viewBox={`0 0 1440 ${currentHeight}`}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    className="w-full h-full"
                >
                    <path
                        /* Cubic Bézier path for architectural tension */
                        d={`M0 ${currentHeight} C480 0 960 0 1440 ${currentHeight} V${currentHeight} H0 Z`}
                        fill={color}
                        style={{ filter: 'drop-shadow(0px -10px 20px rgba(0,0,0,0.1))' }}
                    />
                </svg>
            </div>

            {/* 2. The Content Background & Children Slot */}
            <div
                className="relative z-10 w-full"
                style={{
                    backgroundColor: color,
                    marginTop: `-${currentOffset}px`
                }}
            >
                {children}
            </div>
        </section>
    );
};

export default VaultDome;